export const API_activities_point = (_id: string, params: string): string =>
  `/api/v1/activities/points/${_id}?${params}`;
